"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var SpecificComponentPropType = function SpecificComponentPropType(expectedPropType, expectedPropTypeName) {
  return function (props, propName, componentName) {
    var error;
    if (props[propName]) {
      var value = props[propName];
      if (expectedPropType !== value.type) {
        error = new Error("".concat(componentName, ": ").concat(propName, " should be of type '").concat(expectedPropTypeName, "'"));
      }
    }
    return error;
  };
};
var _default = exports["default"] = SpecificComponentPropType;